import { Button, Center, Stack, Title, Text, Group } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import routes from '@commons/routes';

export const EmptyStatePage = ({
  heading,
  content,
  icon,
}: {
  heading: string;
  content: string;
  icon?: React.ReactNode;
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <Center h="100vh">
      <Stack align="center" gap="xl">
        <Stack align="center" gap="md">
          {icon || <IconAlertCircle size={120} />}
          <Title order={2} ta="center">
            {heading}
          </Title>
          <Text size="md" c="dimmed" ta="center">
            {content}
          </Text>
        </Stack>

        <Group>
          <Button
            variant="outline"
            onClick={() => {
              window.location.reload();
            }}
          >
            {intl.formatMessage({ id: 'refresh' })}
          </Button>

          <Button
            variant="filled"
            onClick={() => {
              navigate(routes.routes.root);
            }}
          >
            {intl.formatMessage({ id: 'firstPage' })}
          </Button>
        </Group>
      </Stack>
    </Center>
  );
};
